'use client'

import { type HTMLAttributes } from 'react'

import { useSession } from '@src/hooks/useSession'
import { getBuilderPreviewMode } from '@src/utils/builder.util'
import { cn } from '@src/utils/tailwind'

interface Props {
  children: React.ReactNode
  attributes: HTMLAttributes<HTMLDivElement> & { key: string }
  className?: string
  showIfLoggedIn: boolean
}

export function LoggedInConditionalContent(props: Props) {
  const { attributes, className, showIfLoggedIn, children } = props
  const { user } = useSession()
  const { edit } = getBuilderPreviewMode()
  const content = (
    <div
      {...attributes}
      key={attributes?.key}
      className={cn('size-auto', className, attributes?.className, {
        'border-4 border-yellow-300 relative': edit,
      })}
      style={{ ...attributes?.style }}
      suppressHydrationWarning
    >
      {children}
    </div>
  )
  if (edit) return content
  if (showIfLoggedIn && !!user) return content
  if (!showIfLoggedIn && !user) return content
  return null
}
